import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment } from "vue"

import {
    OnlineChatMessageToClientActionDescription
} from "~/cabinet/ts/data/events/ActionDescription";
import InputWithVariablesPreview from "~/cabinet/vue/interface/tinymce/InputWithVariablesPreview.vue";
import {useActionBlockOutputProps} from "~/cabinet/vue/client/events/action/types/useActionBlockOutput";
import {computed, inject} from "vue";
import {
    FlowChartEditBlockByIdInjectionKey,
    FlowChartGetBlockByIdInjectionKey
} from "~/cabinet/vue/interface/flowChart/FlowChartInterfaces";
import ActionBlockOutputError from "~/cabinet/vue/client/events/action/ActionBlockOutputError.vue";
import ActionBlock from "~/cabinet/ts/data/events/ActionBlock";


const __default__ = {
    name: "OnlineChatMessageToClientBlockOutput"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    ...useActionBlockOutputProps<OnlineChatMessageToClientActionDescription>()
},
  setup(__props) {

let props = __props;

let getBlockById = inject(FlowChartGetBlockByIdInjectionKey, (blockId: string) => null);
let editBlockById = inject(FlowChartEditBlockByIdInjectionKey, (blockId: string) => null);

let fastTravelBlock = computed(() => {
    let color = "red";
    let block: ActionBlock;
    let blockId = props.output.customDisplayParams?.fastTravelBlockId;
    if (blockId) {
        block = getBlockById(blockId);
        if (block?.isPointOfFastTravel) {
            color = "greensea";
        }
    }
    if (props.output.color !== color) {
        props.output.color = color;
    }
    return block;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (_unref(props).output.customDisplayParams?.isFastTravel && _unref(props).output.customDisplayParams?.fastTravelBlockId)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (_unref(fastTravelBlock))
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (_unref(fastTravelBlock).isPointOfFastTravel)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      class: "link-dashed",
                      tabindex: "",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(editBlockById)(_unref(fastTravelBlock).id)))
                    }, _toDisplayString(_unref(fastTravelBlock).pointOfFastTravelDescr ?? 'Вернуться'), 1))
                  : (_openBlock(), _createBlock(ActionBlockOutputError, { key: 1 }, {
                      default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                        _createTextVNode("Переход к блоку, в котором на данный момент отключен быстрый переход, не будет работать. ", -1)
                      ]))]),
                      _: 1
                    }))
              ], 64))
            : (_openBlock(), _createBlock(ActionBlockOutputError, { key: 1 }, {
                default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                  _createTextVNode("Переход к удалённому блоку не будет работать.", -1)
                ]))]),
                _: 1
              }))
        ], 64))
      : (_openBlock(), _createBlock(InputWithVariablesPreview, {
          key: 1,
          text: _unref(props).output.descr,
          variables: _ctx.contentVariables
        }, null, 8, ["text", "variables"]))
  ]))
}
}

})